<div class="margin">
  <panel>
    <div class="panel_header_title_flx">
      <div>
          <h3 style="padding-top: 16px;padding-right: 9px;">{{panelHeading | translate | async}}</h3>
      </div>
     
       <div class="photo-container">
              <div  class="photo-container">
               <ng-container *ngFor="let photo of system.SystemImages">
                <div>
                  <img class="inspection-observation-photo" [src]="photo.ImageUrl"
                    (click)="viewComponentPhoto(photo.Id,photo.InspectionDetailId,c,  5,photo.SystemId)" />
                </div>
              </ng-container>

                
                <upload-photo  (SystemPhotoUpload)="loadSystemImages($event)"  [inspectionId]="inspectionId" [inspectionDetailId]="system.Id" [comingFrom]="5"></upload-photo>
               
                 <i class="material-icons upload-container__icon"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor:pointer; margin-bottom: 5px;"
                   *ngIf="system.SystemImages?.length >0" (click)="viewComponentHistoryPhoto(null, true,system)">
                  photo_library
                </i>
                 <i class="material-icons upload-container__icon"
                   style="border: 1px solid #ccc8c9;color: #ccc8c9; padding: 8px; cursor:pointer; margin-bottom: 5px;"
                  *ngIf="system.SystemImages?.length == 0" (click)="viewComponentHistoryPhoto(null, true,system)">
                  photo_library
                </i>
              </div>
              <div>
                <add-component-comment  (SystemPhotoUpload)="loadSystemImages($event)"  [inspectionId]="inspectionId" 
                  [comment]="system.SystemComment" [SystemId]="system.Id" [type]="system.Type"
                   [ScreenId] = "7" ></add-component-comment>
              </div>
              </div>
      <div class="panel__header__title serialnumber" style="text-align: end" *ngIf="systemName=='Frame' || (system.Type == UCSystemType.EqualiserBar && IsCondition)">
            {{ (system.Type == UCSystemType.EqualiserBar ? 'Condition' : 'Frame Condition') | translate | async }}
        <select class="frameconditionoptions" [ngModel]="system.Type == UCSystemType.EqualiserBar ? system.Components[0]?.Condition : system.SystemCondition"
          [ngClass]="getConditionClass(system.Type == UCSystemType.EqualiserBar ? system.Components[0]?.Condition : system.SystemCondition)"
          (change)="updateSystemCondition(system, $event.target.value)"
          [title]="isInspector ? 'Click to edit condition' : ''">
          <option value="A" class="frameconditionoptionscolorA">A</option>
          <option value="B" class="frameconditionoptionscolorB">B</option>
          <option value="C" class="frameconditionoptionscolorC">C</option>
          <option value="X" class="frameconditionoptionscolorX">X</option>
        </select>
      </div>
    </div>
    <div class="system-overview">
      <overview-image size="140" *ngIf="!FamilyImage_Chain && systemName=='Chain' " src="/Content/Images/chain.jpg"
        [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Chain && systemName=='Chain'" [src]="getImage_(FamilyImage_Chain)"
        [loading]="loadingSystems"></overview-image>

      <overview-image size="140" *ngIf="!FamilyImage_Frame && systemName=='Frame' " src="/Content/Images/frame.jpg"
        [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Frame && systemName=='Frame'" [src]="getImage_(FamilyImage_Frame)"
        [loading]="loadingSystems"></overview-image>
      <img class="equaliser-image" *ngIf="system.Type == UCSystemType.EqualiserBar" src="/Content/Images/EqualiserBarFront.png">

      <div class="system-overview__content">

        <div class="column-container">
          <div class="column-container__column" *ngIf="system.Type != UCSystemType.EqualiserBar">
            <item-group>
              <item [label]="'Serial Number' | translate | async" class="srnumber" [primary]="true"
                [loading]="loadingSystems">
                {{system.SerialNumber}}
              </item>
              <i class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                title="Edit Serial Number" (click)="EditSerial(system)">
                create
              </i>
            </item-group>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Date Installed' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.DateInstalled | date:'dd/MMM/yyyy'}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Equipment SMU/Hourmeter at Install' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.SmuAtInstall}}
              </span>
            </div>
          </div>
          <div class="column-container__column" >

            <div class="text-block" *ngIf="systemName =='Frame' || system.Type == UCSystemType.EqualiserBar">
              <span class="text-block__label">
                {{ 'Budget Life' | translate | async }}
              </span>
              <span class="text-block__important">
                <span *ngIf="!editableSystemBudgetLife">
                  {{system.BudgetLife}} hrs
                  <i *ngIf="isInspector" class="material-icons text-container__edit"
                    style="cursor: pointer; font-size :16px;" title="Edit Budget Life"
                    (click)="editSysBudgetLife(system.Id)">edit</i>
                </span>
                <span *ngIf="editableSystemBudgetLife" class="text-block__important divflex">
                  <span>
                    <input #dataInput [id]="'dataInputBudgetLife_' + system.Id" [value]="system.BudgetLife"
                      [(ngModel)]="system.BudgetLife" focusOnShow />
                  </span>
                  <span>
                    <i class="material-icons save-button__icon editcancel" title="{{'Save Changes'  | translate | async}}"
                      (click)="onSaveSysBudgetLife(system.Id,system.BudgetLife)">check</i>
                  </span>
                  <span>
                    <i class="material-icons cancel-button__icon editcancel" title="{{'Cancel Changes'  | translate | async}}"
                      (click)="onCancelSysBudgetLife()">close</i>
                  </span>
                </span>
              </span>
            </div>
            <div class="text-block" *ngIf="systemName =='Frame'">
              <span class="text-block__label">
                {{ 'Distance Budget' | translate | async }}
              </span>
              <span class="text-block__important">
                <span *ngIf="!editableSysBudgetDistance">
                  {{system.BudgetDistance}} km
                  <i *ngIf="isInspector" class="material-icons text-container__edit"
                    style="cursor: pointer; font-size :16px;" title="Edit Distance Budget"
                    (click)="editSysBudgetDistance(system.Id)">edit</i>
                </span>
                <span *ngIf="editableSysBudgetDistance" class="text-block__important divflex">
                  <span>
                    <input #dataInput [id]="'dataInputBudgetDistance_' + system.Id" [value]="system.BudgetDistance"
                      [(ngModel)]="system.BudgetDistance" focusOnShow />
                  </span>

                  <i class="material-icons save-button__icon editcancel" title="Save Changes"
                    (click)="onSaveSysBudgetDistance(system.Id,system.BudgetDistance)">check</i>
                  <i class="material-icons cancel-button__icon editcancel" title="Cancel Changes"
                    (click)="onCancelSysBudgetDistance()">close</i>
                </span>
              </span>
            </div>
          </div>
          <div class="column-container__column" >
            <div class="text-block" *ngIf="systemName=='Frame' || system.Type == UCSystemType.EqualiserBar">
              <span class="text-block__label">
                {{ 'Life Lived' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.LifeLived}} hrs
              </span>
            </div>
            <div class="text-block" *ngIf="systemName=='Frame'">
              <span class="text-block__label">
                {{ 'Life Lived' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.LifeLivedKm}} km
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="systemName=='Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Residual Life' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.BudgetLife > 0 ? system.BudgetLife - system.LifeLived : 0}} hrs
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Residual Life' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.BudgetDistance > 0 ? system.BudgetDistance - system.LifeLivedKm : 0}} km
              </span>
            </div>
          </div>
          <!-- <div class="column-container__column" *ngIf="systemName=='Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'SMU At CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.SmuAtCO}} hrs
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'DOE At CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.DOEAtCO}} km
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="systemName=='Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Forecast Date of CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.SMUDateCO | date:'dd/MMM/yyyy'}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Forecast Date of CO' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.DOEDateCO | date:'dd/MMM/yyyy'}}
              </span>
            </div>
          </div> -->
          <div class="column-container__column" *ngIf="systemName=='Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Frame Cost' | translate | async }}
              </span>
              <span class="text-block__important">
                ${{system.FrameCost }}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Frame Repair Cost' | translate | async }}
              </span>
              <span class="text-block__important">
                $0.00
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="systemName=='Frame'">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Total Purchase Cost (inc. Current Components)' | translate | async }}
              </span>
              <span class="text-block__important">
                ${{system.TotalComponentPurchaseCost}}.00
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Total Component Repairs Cost (inc. All Components Ever)' | translate | async }}
              </span>
              <span class="text-block__important">
                ${{system.TotalComponentRepairsCost}}.00
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="system.Type == UCSystemType.EqualiserBar">
            <div class="text-block">
              <span class="text-block__label">
                {{ 'Brand' | translate | async }}
              </span>
              <span class="text-block__important">
                {{system.Make}}
              </span>
            </div>
          </div>
          <div class="column-container__column" *ngIf="systemName=='Frame'">
            <!--*ngIf="(equipmentDetails.FamilyId!=177 && equipmentDetails.FamilyId!=203)"-->
            <div class="text-block" *ngIf="showFrameConfigurattion">
              <span class="text-block__label">
                {{ 'Frame Configuration' | translate | async }}
              </span>
              <span class="text-block__important">
                <ng-container *ngIf="system.ToeOutFrame == 0">
                  Unknown
                </ng-container>
                <ng-container *ngIf="system.ToeOutFrame == 1">
                  {{ 'Toe Out' | translate | async }}
                </ng-container>
                <ng-container *ngIf="system.ToeOutFrame == 2">
                  {{ 'Straight' | translate | async }}
                </ng-container>
                <ng-container *ngIf="isInspector">
                  <a (click)="openTrackCofiguration(1,system.ToeOutFrame,system.Id,system.Side)">
                    <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
                  </a>
                </ng-container>
              </span>
            </div>
            <!-- <div class="text-block" *ngIf="!showradio"> -->
            <!-- This above check is removed and this new is added TT-9496  -->
            <div class="text-block" *ngIf="showCannonType">
              <span class="text-block__label">
                {{ 'Cannon Type' | translate | async }}
              </span>
              <span class="text-block__important">
                <ng-container *ngIf="system.CastFrame == 0">
                  Unknown
                </ng-container>
                <ng-container *ngIf="system.CastFrame == 1">
                  {{ 'Cast' | translate | async }}
                </ng-container>
                <ng-container *ngIf="system.CastFrame == 2">
                  {{ 'Fabricated' | translate | async }}
                </ng-container>
                <ng-container *ngIf="isInspector">
                  <a (click)="openTrackCofiguration(2,system.CastFrame,system.Id,system.Side)">
                    <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer;">create</i>
                  </a>
                </ng-container>
              </span>
            </div>
            <!-- TT-10043 -->
            <div class="mtm-10" *ngIf="enableBogieShim">
             <app-bogie-shim [bogieShimL]="system.BogieShimLeft" [bogieShimR]="system.BogieShimRight" [side]="system.Side" [isViewMode]="false" [isInterp]=" true"></app-bogie-shim>
             </div>
          </div>

        </div>
        

      </div>
    </div>
    <div class="table-container" [@slideOut] *ngIf="system.Components.length > 0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <!-- <th></th> -->
            <th *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th>{{'Component' | translate | async}}</th>
            <th *ngIf="editComponentType">{{'Component Type' | translate | async}}</th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar">{{'Pos.' | translate | async}}</th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar">{{'Worn' | translate | async}}</th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar" class="right-align" style="text-align-last: center;">{{'Measurement' | translate | async}}</th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar">{{'Tool' | translate | async}}</th>
            <th *ngIf="UTEquivalenetEnabled && system.ShowUTequvelent  && system.Type != UCSystemType.EqualiserBar">{{'UT Equivalent' | translate | async}}</th>
            <th *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th class="right-align" *ngIf="showCMU  && system.Type != UCSystemType.EqualiserBar">{{'CMU' | translate | async}}</th>
            <th class="right-align" *ngIf="showResLife100  && system.Type != UCSystemType.EqualiserBar">{{'Res. Life' | translate | async}} 100%</th>
            <th class="right-align" *ngIf="showResLife120  && system.Type != UCSystemType.EqualiserBar">{{'Res. Life' | translate | async}} 120%</th>
            <th class="right-align" *ngIf="showDOC && showDistTravelledTracking  && system.Type != UCSystemType.EqualiserBar">{{'DOC' | translate | async}}
              ({{userUOD}})</th>
            <th class="right-align" *ngIf="showResDOC100 && showDistTravelledTracking  && system.Type != UCSystemType.EqualiserBar">{{'Res. DOC' | translate |
              async}} 100% ({{userUOD}})</th>
            <th class="right-align" *ngIf="showResDOC120 && showDistTravelledTracking  && system.Type != UCSystemType.EqualiserBar">{{'Res. DOC' | translate |
              async}} 120% ({{userUOD}})</th>
            <th class="inspection-component-photo-header" *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th class="inspection-component-photo-header" *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th class="inspection-component-photo-header" *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th class="inspection-component-photo-header" *ngIf="system.Type != UCSystemType.EqualiserBar"></th>
            <th class="right-align" style="text-align-last: left;" *ngIf="system.Type == UCSystemType.EqualiserBar">{{'Type'}}</th>
            <th class="right-align" style="text-align-last: left;" *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">{{'Measurement Center'}}</th>
            <th class="right-align" style="text-align-last: left;" *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">{{'Measurement Outer Left'}}</th>
            <th class="right-align" style="text-align-last: left;" *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">{{'Measurement Outer Right'}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of system.Components">
            <!-- <td *ngIf="c.IsChild">
              <span style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
              </span>
            </td> -->
            <td class="component-cell" *ngIf="!c.IsChild && system.Type != UCSystemType.EqualiserBar">
              <div class="component-photo-container">
                <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
              </div>
            </td>
            <td *ngIf="c.IsChild && system.Type != UCSystemType.EqualiserBar" class="line-cell">
              <div class="line-vert{{getChildRowPosition(c.ComponentId)}}"></div>
              <div class="line-hor"></div>
            </td>

            <td>
              <span title="{{c.Name}}" *ngIf="!c.IsChild && c.ComponentPitch == null">
                {{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
              </span>
              <span title="{{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '')}}" *ngIf="!c.IsChild && c.ComponentPitch != null">
                {{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '') | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
              </span>
              <span title="{{c.Name}}" *ngIf="c.IsChild && c.ComponentPitch == null">
                {{c.Name | slice:0:30}} {{
                c.Name.length>30 ? '...' :
                ''
                }}
              </span>
              <span title="{{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '')}}" *ngIf="c.IsChild && c.ComponentPitch != null">
                {{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '') | slice:0:30}} {{
                c.Name.length>30 ? '...' :
                ''
                }}
              </span>
            </td>
            <td *ngIf="editComponentType && system.Type != UCSystemType.EqualiserBar">
              <mat-form-field class="input">
                <mat-select>
                  <mat-option>
                    {{c.CompartId_Auto}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>


            <td *ngIf="c.IsChild && system.Type != UCSystemType.EqualiserBar"></td>
            <td *ngIf="!c.IsChild && system.Type != UCSystemType.EqualiserBar"> {{showPosition(c.Pos, c.ComponentTypeId)}}</td>

            <!-- <td class="table__eval-cell"><span style="width: 80px;" class="Eval-{{c.WornPercentage.toFixed(1) | wornPercentageToEval }}"> -->
            <td *ngIf="system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!isParent(c.ComponentId)" style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                <div style="text-align: center !important; display: inline-block;">
                  <!-- Eval tool -->
                  <ng-container *ngIf="c.ToolId === toolType.Eval">
                    {{ c.EvalCode }}
                  </ng-container>

                   <ng-container *ngIf="c.ToolId === toolType.ConditionAssessment">
                    {{ c.EvalCode === 'A' ? 'Good' : c.EvalCode === 'B' ? 'Monitor' :    c.EvalCode === 'X' ? 'Failed' :'Good' }}
                    <!-- Monitor -->
                  </ng-container>

                  <!-- Yes/No or Pass/Fail -->
                  <ng-container *ngIf="c.ToolId === toolType.YESorNO || c.ToolId === toolType.PassorFail">
                    {{'-'}}
                  </ng-container>

                  <!-- All others -->
                  <ng-container
                    *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail && c.ToolId != toolType.ConditionAssessment">
                    {{ c.Measurement === -1 ? '-' : (c.WornPercentage.toFixed(1) + '%') }}
                  </ng-container>
                  
                </div>
              </span>
            </td>
            <td *ngIf="system.Type != UCSystemType.EqualiserBar">
              <i style="align-self: center;cursor: pointer;margin-left: -28px;" *ngIf="c.hasMultipleMeasurement"
                (click)="showMultipleMeasurements(c)" class="material-icons sc-icon">info</i>
            </td>
            <td *ngIf="system.Type != UCSystemType.EqualiserBar"
              [ngStyle]="(c.Tool === 'Eval' || c.ToolId === toolType.YESorNO || c.ToolId === toolType.PassorFail || c.ToolId === toolType.ConditionAssessment) ? {'text-align': 'center'} : null">
              <div *ngIf="!isParent(c.ComponentId)">
              
              <div
                *ngIf="(c.IsChild || !isParent(c.ComponentId)) && c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail &&c.ToolId != toolType.ConditionAssessment"
                style="text-align-last: center;">
                <!-- <click-to-edit [editable]="isInspector" [isInterp]="true" [data]="c.Measurement != -1 ?c.Measurement:null" (dataChanged)="updateComponentMeasurement($event, c.InspectionDetailId)"  [alignRight]="true">
                </click-to-edit> -->

                <input style="width: 100px;" type="number" [(ngModel)]="c.Measurement == -1 ?null : c.Measurement"
                  (change)="updateComponentMeasurement(c.Measurement, c.InspectionDetailId, $event,c)">
                {{unitOfMeasurementShort}}
              </div>
              <div *ngIf="c.ToolId === toolType.Eval">
                <span [matMenuTriggerFor]="evalMenu" class="tool-button"
                  title="{{'Change Eval' | translate | async}}">{{c.EvalCode }}</span>
                <mat-menu #evalMenu="matMenu">
                  <button mat-menu-item (click)="changeEval('A', c.InspectionDetailId,c.ComponentTypeId, c.ToolId)">
                    {{
                    'A' |
                    translate | async
                    }}
                  </button>
                  <button mat-menu-item (click)="changeEval('B', c.InspectionDetailId,c.ComponentTypeId, c.ToolId)">
                    {{
                    'B' |
                    translate | async
                    }}
                  </button>
                  <button *ngIf="c.isExcludeC==false" mat-menu-item
                    (click)="changeEval('C', c.InspectionDetailId,c.ComponentTypeId, c.ToolId)">
                    {{
                    'C' | translate |
                    async
                    }}
                  </button>
                  <button mat-menu-item (click)="changeEval('X', c.InspectionDetailId,c.ComponentTypeId, c.ToolId)">
                    {{
                    'X' |
                    translate | async
                    }}
                  </button>
                </mat-menu>
              </div>
             
               <div *ngIf="c.ToolId === toolType.ConditionAssessment">
                <span [matMenuTriggerFor]="testMenu" class="tool-button"
                  title="{{'Change Tool' | translate | async}}">{{ c.EvalCode === 'A' ? 'Good' : c.EvalCode === 'B' ? 'Monitor' :    c.EvalCode === 'X' ? 'Failed' :'Good' }}</span>
                <mat-menu #testMenu="matMenu">
                  <button mat-menu-item (click)="changeEval('Good', c.InspectionDetailId,c.ComponentTypeId, toolType.ConditionAssessment)">
                    {{
                    'Good' |
                    translate | async
                    }}
                  </button>
                  <button mat-menu-item (click)="changeEval('Monitor', c.InspectionDetailId,c.ComponentTypeId, toolType.ConditionAssessment)">
                    {{
                    'Monitor' |
                    translate | async
                    }}
                  </button>
                  <button mat-menu-item
                    (click)="changeEval('Failed', c.InspectionDetailId,c.ComponentTypeId, toolType.ConditionAssessment)">
                    {{
                    'Failed' | translate |
                    async
                    }}
                  </button>
                  
                </mat-menu>
              </div>

              <div *ngIf='c.ToolId === toolType.YESorNO'>
                <span [matMenuTriggerFor]="yesNoMenu" class="tool-button"
                  title="{{ 'Change Component Yes/No' | translate | async }}">
                 {{ 
                  c.Measurement === -1 
                    ? 'U' 
                    : (c.Measurement === 1 
                        ? ('Yes' | translate | async) 
                        : ('No' | translate | async)
                      ) 
                }}
                </span>
                <mat-menu #yesNoMenu="matMenu">
                  <button mat-menu-item (click)="onToolOptionSelect(c, toolTypeYesNo.Yes)">{{ 'Yes' | translate | async
                    }}</button>
                  <button mat-menu-item (click)="onToolOptionSelect(c, toolTypeYesNo.No)">{{ 'No' | translate | async
                    }}</button>
                </mat-menu>
              </div>
              <div *ngIf='c.ToolId === toolType.PassorFail'>
                <span [matMenuTriggerFor]="passFailMenu" class="tool-button"
                  title="{{ 'Change Component Pass/Fail' | translate | async }}">
                  {{ 
                c.Measurement === -1 
                  ? 'U' 
                  : (c.Measurement === 1 ? ('Pass' | translate | async) : ('Fail' | translate | async)
                    ) 
              }}
                        
                </span>
                <mat-menu #passFailMenu="matMenu">
                  <button mat-menu-item (click)="onToolOptionSelect(c, toolTypePassFail.Pass)">{{ 'Pass' | translate |
                    async }}</button>
                  <button mat-menu-item (click)="onToolOptionSelect(c, toolTypePassFail.Fail)">{{ 'Fail' | translate |
                    async }}</button>
                </mat-menu>
              </div>
            </div>
            </td>
            <td *ngIf="system.Type != UCSystemType.EqualiserBar">
              <div *ngIf="(c.IsChild || !isParent(c.ComponentId))  && isInspector">
                <span [matMenuTriggerFor]="selectToolMenu" class="tool-button"
                  title="{{'Change tool' | translate | async}}">{{c.Tool}}</span>
                <mat-menu #selectToolMenu="matMenu">
                  <button mat-menu-item *ngFor="let tool of c.PossibleTools"
                    (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, tool.ToolId)">
                    {{
                    tool.ToolName |
                    translate | async
                    }}
                  </button>
                  <!-- <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 2)">{{'Depth Gauge' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 3)">{{'Ultrasonic' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 4)">{{'Calipers' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 9)">{{'Eval' | translate | async}}</button> -->
                </mat-menu>
              </div>
              <span *ngIf="(c.IsChild || !isParent(c.ComponentId)) && !isInspector">{{c.Tool}}</span>
            </td>
            <td *ngIf="UTEquivalenetEnabled && system.ShowUTequvelent && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="(c.IsChild || !isParent(c.ComponentId)) && isInspector && c.Tool!='UT' && c.hasUTTool">
                {{c.UTequvelent}}
                {{unitOfMeasurementShort}}
              </span>
            </td>
            <td class="component-cell" *ngIf="!c.IsChild && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="c.flag_on"
                style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor:pointer;">
                <i (click)="onClickFlag(c)" style="color: #ed5565" class="material-icons sc-icon">flag</i>
              </span>
            </td>
            <td class="right-align" *ngIf="showCMU  && system.Type != UCSystemType.EqualiserBar"><span *ngIf="!c.IsChild">{{c.Cmu}} hrs</span></td>
            <td class="right-align" *ngIf="showResLife100  && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!c.IsChild">{{c.RisidualLife100}} hrs</span>
            </td>
            <td class="right-align" *ngIf="showResLife120  && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!c.IsChild">{{c.RisidualLife120}} hrs</span>
            </td>
            <td *ngIf="c.IsChild && system.Type != UCSystemType.EqualiserBar"></td>
            <td class="right-align" *ngIf="showDOC && showDistTravelledTracking && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!c.IsChild">
                {{convertDistanceKmToMi(c.DOC)}}
              </span>
            </td>
            <td class="right-align" *ngIf="showResDOC100 && showDistTravelledTracking  && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!c.IsChild">{{convertDistanceKmToMi(c.ResidualDOC100)}}</span>
            </td>
            <td class="right-align" *ngIf="showResDOC120 && showDistTravelledTracking  && system.Type != UCSystemType.EqualiserBar">
              <span *ngIf="!c.IsChild">{{convertDistanceKmToMi(c.ResidualDOC120)}}</span>
            </td>
            <td class="inspection-component-photo" *ngIf="system.Type != UCSystemType.EqualiserBar">
              <div class="photo-container">
              <div *ngIf="!isParent(c.ComponentId) && isInspector" class="photo-container">
                <upload-photo  (onPhotoUpload)="loadPhoto(c)"
                  [inspectionId]="inspectionId" [inspectionDetailId]="c.InspectionDetailId"></upload-photo>
                <!-- <img (click)="viewComponentPhoto(c.PhotoId)" class="inspection-component-photo__photo" [src]="c.PhotoThumbnail" *ngIf="c.PhotoThumbnail != ''" /> -->
                <!-- <i *ngIf="c.PhotoThumbnail != ''" class="material-icons upload-container__icon"
                   style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                   (click)="viewComponentPhoto(c.PhotoId,c.InspectionDetailId,c)">
                  add_a_photo
                </i> -->

                <i class="material-icons upload-container__icon" *ngIf="c.ComponentImages.length>0"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor:pointer; margin-bottom: 5px;"
                  (click)="viewComponentHistoryPhoto(c)">
                  photo_library
                </i>
                <i class="material-icons upload-container__icon" *ngIf="c.ComponentImages.length==0"
                  style="border: 1px solid #ccc8c9;color: #ccc8c9; padding: 8px; cursor:pointer;margin-bottom: 5px;"
                  (click)="viewComponentHistoryPhoto(c)">
                  photo_library
                </i>
              </div>
              <ng-container *ngFor="let photo of c.ComponentImages">
                <div>
                  <img class="inspection-observation-photo" [src]="sanitize_PI(photo.ComponentImageUrl)"
                    (click)="viewComponentPhoto(photo.Id,photo.InspectionDetailId,c)" />
                </div>
              </ng-container>
              </div>
              <!-- (click)="viewObservationListPhoto(ob,photo)" -->

            </td>

            <td class="inspection-component-photo" *ngIf="system.Type != UCSystemType.EqualiserBar">
              <div *ngIf="!isParent(c.ComponentId) ">
                <!-- <div class="form-input">
                  <textarea class="form-textarea" rows="3"  autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="c.Comment"
                  style="resize:vertical;width: 300px;"  (change)="updateComponentComment(inspectionId,c.InspectionDetailId,c.Comment)">
                    </textarea>
                </div> -->
                <!-- <add-component-comment (onCommentChange)="loadSystem()" [comment]="c.Comment" [inspectionId]="inspectionId" [inspectionDetailId]="c.InspectionDetailId"></add-component-comment> -->
                <add-component-comment (onCommentChange)="loadComment(c)" (updateComment)="updateComment"
                  [comment]="c.Comment" [CompartTypeId]="c.ComponentTypeId" [inspectionId]="inspectionId"
                  [inspectionDetailId]="c.InspectionDetailId" [ScreenId] = "7"></add-component-comment>

              </div>
            </td>

            <td class="inspection-component-photo" *ngIf="system.Type != UCSystemType.EqualiserBar">
              <div class="add-recommendation" *ngIf="!c.IsChild && isInspector"
                [class.has-recommendation]="componentHasRecommendation(c.ComponentId)">
                <i title="Add Recommendation" class="material-icons"
                  (click)="openAddEditRecommendation(c.ComponentId, c.RecommendationId)">rate_review</i>
              </div>
            </td>
            <td *ngIf="system.Type != UCSystemType.EqualiserBar">
              <i *ngIf="c.IsFlagged && c.RemovedFromActionTaken" class="material-icons"
                style="color:red;cursor: pointer;" [matMenuTriggerFor]="menu">flag</i>
              <i *ngIf="c.IsFlagged && !c.ActionTaken && !c.RemovedFromActionTaken" class="material-icons"
                style="color:rgb(165, 164, 164);cursor: pointer;"
                title="Please record action for the component.">flag</i>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="resetFlaggedComponent(c)">
                  <span>Action Component Replacement</span>
                </button>
                <button mat-menu-item (click)="OpenFlaggedComponent(c)">
                  <span>Change Component Details</span>
                </button>
              </mat-menu>
            </td>
            <td *ngIf="system.Type == UCSystemType.EqualiserBar">
              <div style="text-align-last: left;">
                <mat-radio-group
                  [(ngModel)]="eqBarToeOut"
                  (change)="updateComponentMeasurementEq('ToeOut', eqBarToeOut, c.InspectionDetailId, $event,c)"
                  class="equaliser-type-radio">
                  <mat-radio-button [value]="1">
                    {{'Toe Out' | translate | async}}
                  </mat-radio-button>
                  <mat-radio-button [value]="2">
                    {{'Straight' | translate | async}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </td>
            <td *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">
              <div style="text-align-last: left;">
                <input style="width: 100px;" type="number" [(ngModel)]="c.MeasurementCenter == -1 ? null : c.MeasurementCenter"
                  (change)="updateComponentMeasurementEq('MC', c.MeasurementCenter, c.InspectionDetailId, $event,c)"
                  [ngClass]="borderClassCenter" >
                {{unitOfMeasurementShort}}
              </div>
            </td>
            <td *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">
              <div style="text-align-last: left;">
                <input style="width: 100px;" type="number" [(ngModel)]="c.MeasurementOuterLeft == -1 ? null : c.MeasurementOuterLeft"
                  (change)="updateComponentMeasurementEq('MOL', c.MeasurementOuterLeft, c.InspectionDetailId, $event, c )"
                  [ngClass]="borderClassOLeft" >
                {{unitOfMeasurementShort}}
              </div>
            </td>
            <td *ngIf="system.Type == UCSystemType.EqualiserBar && !IsCondition">
              <div style="text-align-last: left;">
                <input style="width: 100px;" type="number" [(ngModel)]="c.MeasurementOuterRight == -1 ? null : c.MeasurementOuterRight"
                  (change)="updateComponentMeasurementEq('MOR', c.MeasurementOuterRight, c.InspectionDetailId, $event,c)"
                  [ngClass]="borderClassORight" >
                {{unitOfMeasurementShort}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    
  </panel>
</div>

<div *ngIf="removeFlagPopup && system.Type != UCSystemType.EqualiserBar" class="ttmodal-backdrop">
  <div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{'Remove Flag' | translate | async}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onClickCloseFlag()">close</i>
  </div>
  <div class="ttmodal__body">
      <form>
        <mat-form-field class="header-form-full-width-spinner">
          <input matInput name="flag_comment" [(ngModel)]="flag_comment" placeholder="Comment">
        </mat-form-field>
      </form>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onClickCloseFlag()">{{'Cancel' | translate | async}}</button>
    <button mat-raised-button (click)="onClickRemoveFlag()" color="warn">{{'Remove Flag' | translate | async}}</button>
  </div>
</div>
</div>
